import React from "react";
import { MessageSquare, X } from "lucide-react";
import { motion } from "framer-motion";
import useAvatarStore from "../stores/avatarStore";

const FloatingChatButton = () => {
  const { chatOpen, setChatOpen } = useAvatarStore();

  if (chatOpen) return null;

  return (
    <motion.button
      onClick={() => setChatOpen(!chatOpen)}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className={`absolute top-20 right-6 z-30 w-12 h-12 rounded-full flex items-center justify-center shadow-xl border transition-all duration-300 ${
        chatOpen
          ? "bg-rose-600/90 hover:bg-rose-500 border-rose-500/20 text-white"
          : "bg-white hover:bg-gray-50 border-gray-200 text-secondary"
      }`}
      title={chatOpen ? "Close Chat Panel" : "Open Chat Panel"}
    >
      {chatOpen ? <X className="w-5 h-5" /> : <MessageSquare className="w-5 h-5" />}
    </motion.button>
  );
};

export default FloatingChatButton;
